/**
 * login.tsx — Auth split layout + login form.
 *
 * Lives at `/login`. The shell hides for this path so the auth split layout
 * takes the full page. Reads an optional `?error=session` flag to render a
 * friendly "session expired" banner.
 *
 * The page is intentionally generic: it does not enumerate which roles can
 * log in. The system decides where to send the user after a successful
 * sign-in based on the session principal.
 */

import type { ReactNode } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { LoginForm } from '../components/auth/LoginForm.js';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>) => ({
    error: typeof search['error'] === 'string' ? search['error'] : undefined,
    redirect: typeof search['redirect'] === 'string' ? search['redirect'] : undefined,
  }),
  component: LoginPage,
});

function LoginPage(): ReactNode {
  const { error } = Route.useSearch();
  const errorMessage = error === 'session' ? 'Sesi kamu sudah berakhir. Silakan masuk lagi.' : null;

  return (
    <main className="page-shell">
      <div className="auth-split">
        <aside className="auth-split-aside" aria-hidden="true">
          <img src="/images/generated/auth-desk/auth-desk.png" alt="" width={1280} height={720} />
        </aside>
        <section className="auth-split-main auth-split-card">
          <p className="page-eyebrow">Coding Class</p>
          <h1>Masuk</h1>
          <p>Lanjutkan progres belajar kamu di kelas Coding Class.</p>
          <LoginForm initialError={errorMessage} />
          <p className="auth-return-link form-message">
            <Link to="/">Kembali ke beranda</Link>
          </p>
        </section>
      </div>
    </main>
  );
}
